import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

export const RefreshButton = styled(Button)`
  text-transform: none !important;
  color: #555;
  :hover {
    background-color: transparent !important;
  }
`;

export const TableToolbarDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;
`;

export const Spacer = styled.div`
  flex-grow: 1;
`;
